import { Stack as MuiStack, StackProps } from "@mui/material";

type Props = StackProps;

export const Stack = ({ children, ...props }: Props) => {
  return <MuiStack {...props}>{children}</MuiStack>;
};
